<template>
    <div style="width: 100%;">
<!--        信息卡片-->
<!--        :style="{backgroundColor: ui.bg_color === '#FFFFFF' ? '#1677FF' : ui.bg_color}"-->
        <div class="card_wrap">
            <div class="top_card">
<!--                :style="{color: ui.btn_font_color ? ui.btn_font_color : '#fff'}"-->
                <div class="new_list_item">
                    <div class="new_middle_info">
                        <div class="new_middle_inner">
                            <div class="info_title" v-if="theme">{{theme}}</div>
                            <div class="info_desc">
                                <img src="../assets/image/jianzhan/time.png"/>
<!--                                <van-icon name="underway-o" />-->
                                <span class="address_text">{{stime_etime}}</span>
                            </div>
                            <div class="info_desc" v-if="address!=''">
<!--                                <van-icon name="location-o" />-->
                                <img src="../assets/image/jianzhan/address.png"/>
                                <span class="address_text">{{address}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="new_right_img">
                        <img src="../assets/image/jianzhan/zeng.png" />
                    </div>

                </div>
                <div class="special coupon_l_b"></div>
                <div class="special coupon_r_b"></div>
                <div class="dashed_x"></div>
            </div>
            <div class="bottom_card">
                <div class="special coupon_l_t"></div>
                <div class="special coupon_r_t"></div>
                <div class="jz_share_btn" @click="clk_copy">邀请好友 免费领票</div>
            </div>

        </div>
<!--        表单-->
        <div class="jz_form_wrap">
            <div class="tip_info" style="align-items: center">
                <p>
                    <span class="blue_span"></span>
                    <span class="gray_span"></span>
                </p>
                <p class="form_title">{{form_title ? form_title : '免费赠票'}}</p>
                <p>
                    <span class="blue_span"></span>
                    <span class="gray_span"></span>
                </p>
            </div>
            <div class="jz_real_from">
                <van-form ref="actionForm">
                    <van-field v-model="action_form.name" label="姓名" name="name" :placeholder="name_placeholder ? name_placeholder : '请输入您的名字'" />
                    <van-field v-model="action_form.phone" label="手机号" name="phone" :placeholder="phone_placeholder ? phone_placeholder : '输入您的手机号(已加密)'" />

                    <div  class="jz_share_btn jz_submit_btn" @click="submitForm" v-if="!is_stop">立即报名</div>
                    <van-button class="form_item_btn"
                                type="info" round v-if="is_stop" :disabled="true">活动已结束
                    </van-button>
                    <div class="policy_tip">
                        <jzpolicy></jzpolicy>
                    </div>
                </van-form>
            </div>
        </div>
<!--        邀请好友-->
        <div class="share_wrap">
            <div class="left_share">
                <img src="../assets/image/jianzhan/share.png">
                <div>
                    <p class="share_title">邀请好友一起逛展</p>
                    <p class="share_tip">点击去邀请，好友可参与免费领取门票</p>
                </div>
            </div>
            <div class="right_share_btn"  @click="clk_copy"><span>去邀请</span></div>
        </div>
<!--        温馨提示-->
        <div class="jz_tip_wrap">
            <div class="top_tip">
                <span class="dot"></span>
                <span style="font-weight: 600;font-size: 18px;color: #000000;">温馨提示</span>
            </div>
            <div class="tip_info">
                <p>1.请您在活动期间，前往乐居家博会现场进行免费参观。</p>
                <p>2.若您遇到问题需要帮助或者咨询，可以联系我们的客服热线。</p>
                <p>热线电话：400-808-1705。</p>
                <p>客服服务时间：周一至周五 9:00-12:00 13:30-18:00。</p>
                <p>请您在工作时间内咨询，避免无人接听给你带来不便。</p>
            </div>
        </div>

<!--        复制成功弹框-->
        <div class="copy_success_wrap" v-if="is_copy_tip">
            <span>已复制，快去分享好友吧～</span>
        </div>
    </div>
</template>

<script>
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import lib_activity from "@/libs/lib_activity";
    import _wx from "@/common/_wx";
    import lib_city from "@/libs/lib_city";
    import Toast from "vant/lib/toast";
    import _regular from "@/utils/_regular";
    import lib_clue from "@/libs/lib_clue";
    import _monitor from "@/monitor/_monitor";
    import cache_url from "@/cache/cache_url";
    import lib_success from "@/libs/lib_success";
    import _geturl from "@/utils/_geturl";
    import jzpolicy from "@/components/jzpolicy";
    import _copyUrl from "@/common/_copyUrl";

    let action_form = {
        name: '', //姓名
        phone: '', //电话
        city: '', //城市
    }

    export default {
        name: "jianzhan",
        components: {jzpolicy},
        props: {
            title:{
                type: String,
                default: ''
            },
            form_title:{
                type: String,
                default: ''
            },
            name_placeholder:{
                type: String,
                default: ''
            },
            phone_placeholder:{
                type: String,
                default: ''
            },
        },
        data() {
            return {
                activity_id: 0, //活动ID
                tids: "", //模板ID
                channel: '', //渠道
                channel_name: '', //渠道名
                tid: 0, // 有无车型库
                theme: '',//主题
                share_theme: '', //分享描述
                stime: 0, // 项目开始时间
                etime: 0, // 项目结束时间
                stime_etime: '', //项目开始-结束时间
                address: '', //项目地址
                ui: {
                    head: '', //头图
                    tail: '', //详情图
                    share: '', //分享图
                    bg_color: '', //表单背景色
                    font_color: '', //文本颜色
                    btn_bg_color: '', //按钮背景色
                    btn_font_color: '', //按钮文本颜色
                    btn_text: '', //按钮文本值
                    btm_btn_text: '', //底部按钮文本
                    is_banner: 0, //是否有轮播图
                    is_counter: 0, //是否有倒计时
                    is_copyright: 1, //协议
                    jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
                },

                action_form: action_form,
                //城市联级选择
                citys: [], //城市数据
                is_city: false, //表单城市项，默认无城市
                is_stop: false, //活动是否已结束
                is_display: true, //底部按钮

                // vant相关
                city_show: false,
                cascaderValue: '', //
                cityNames: {
                    text: 'name',
                    value: 'id',
                    children: 'children',
                },
                share_url: '',
                is_copy_tip: false
            }
        },
        created() {
            // 地址栏
            this.activity_id = _geturl("activity_id");
            this.tids = _geturl("tids");
            this.channel = _geturl("channel");
            this.channel_name = _geturl("channel_name");

            //获取项目信息
            lib_activity.info(this.activity_id, this.tids, this.init_info);

            //监测
            _monitor.init(this.channel, this.activity_id);

        },

        mounted() {
            //定义需要分享的页面地址
            this.share_url = window.location.protocol + '//' + window.location.host + '/page/success/showshare' + '?' + window.location.href.split('?')[1]
            cache_url.set(this.share_url)
            document.title = this.title;
        },

        methods: {
            //初始化项目信息
            init_info(data) {
                console.log(data)
                this.theme = data.activity.theme;
                // document.title = '报名成功';
                // document.title = this.title;
                this.share_theme = data.activity.share_theme;
                this.etime = data.activity.etime;
                this.stime = data.activity.stime;
                this.stime_etime = _time._range_date(this.stime*1000, this.etime*1000);
                this.address = data.activity.address;
                this.tid = data.activity.tid;
                if(data.ui == null) {
                    this.ui = {};
                    return;
                }
                this.ui = data.ui;
                // 项目结束
                if (!data.activity.state || (_time._current() > data.activity.etime)) {
                    this.is_stop = true;
                    return;
                }

                // 判断是否有城市
                let city = []
                if (data.activity.city) {
                    city = data.activity.city.split(',');
                }
                if (city.length == 1 && city[0] > 0) {
                    //单城市项目
                    this.is_city = false;
                } else {
                    //多城市项目
                    this.is_city = true;
                    this.getCity(data.activity.city)
                }
                // 分享： ui存在再分享
                if (_object._length(this.ui) > 0) {
                    this.share();
                }
            },

            // 分享
            share() {
                let that = this;
                lib_activity.share(function (data) {
                    let options = {};
                    options.title = that.theme;
                    options.desc = that.share_theme;
                    options.link = window.location.href;
                    options.img = that.ui.share;

                    _wx.js_api(data, _wx.share, options);
                })
            },
            // 加载城市
            getCity(city) {
                let that = this;
                lib_city.list(city, function (data) {
                    that.citys = data;
                })
            },

            submitForm() {
                if (this.is_city && !this.action_form.city) {
                    Toast('请选择城市');
                    return;
                }
                if (!this.action_form.name) {
                    Toast('请输入您的姓名');
                    return;
                }
                if(this.action_form.name && !_regular.is_china(this.action_form.name)) {
                    Toast('请输入正确的姓名');
                    return;
                }
                if (!this.action_form.phone) {
                    Toast('请输入您的手机号');
                    return;
                }
                if (!_regular.is_mobile(this.action_form.phone)) {
                    Toast('请输入正确的手机号');
                    return;
                }
                let cityArr = this.action_form.city.split('/'); // vant形式
                let location = this.is_city ? (cityArr[0] + '+' + cityArr[1]) : '';
                let url = window.location.href;
                let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;
                let params = {
                    activity_id: this.activity_id,
                    channel_code: this.channel,
                    channel_name: this.channel_name,
                    location,
                    url,
                    form_name: this.action_form.name,
                    form_phone: this.action_form.phone,
                    form_ui_id,
                };
                let that = this;

                lib_clue.receive(params, function (data) {
                    // console.log(data.id, 'id')
                    //监测上报
                    _monitor.submit()
                    //缓存当页面链接
                    // cache_url.set(window.location.href)
                    //跳转
                    //不同参数跳转不同页面
                    // const jmp_url = _object._length(that.ui) > 0 ? that.ui.jmp_url : 0
                    //跳转地址
                    const url = lib_success.jmp_url_jz()
                    that.$router.push({
                        path: url,
                        query: {
                            id: data.id
                        },
                    })
                })
            },

            //复制链接
            clk_copy() {
                let url = cache_url.empty() ? window.location.href : cache_url.get()
                // console.log("亲，我已领取@ [" + this.theme + "] 门票，和我一起逛家博会展览，探索居家好物吧！>>" + ' ' + url)
                _copyUrl.custom_copyUrl("亲，我已领取@ [" + this.theme + "] 门票，和我一起逛家博会展览，探索居家好物吧！>>" + ' ' + url)
                this.is_copy_tip = true;
                if(this.is_copy_tip) {
                    setTimeout(()=>{
                        this.is_copy_tip = false
                    },2000)
                }
            },
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/style/secondary/base.less";
    @import "../assets/style/autoshow/form.less";
    @import "../assets/style/secondary/jianzhan";
    @import "../assets/style/secondary/specialcard";
    // form
    @import "../assets/style/common/successful.less"; // 成功
    /deep/ .el-divider--horizontal {
        margin: 10px 0;
    }
</style>